import { MetricType } from "../../types/api/metrics/metricsType";
import { AvailableMetricResponse } from "../../types/api/metrics/request";
import { FilterConfig, BaseSelectFilter } from "../../types/common/filters";

// Общие фильтры
const platform: BaseSelectFilter = {
    key: 'platform',
    label: 'Платформа',
    options: []
}

const countryId: BaseSelectFilter = {
    key: 'countryResponseForId',
    label: 'Страна',
    options: []
}

const cityId: BaseSelectFilter = {
    key: 'cityResponseForId',
    label: 'Город',
    options: []
}

const countryName: BaseSelectFilter = {
    key: 'countryResponseForName',
    label: 'Страна',
    options: []
}

const cityName: BaseSelectFilter = {
    key: 'cityResponseForName',
    label: 'Город',
    options: []
}

const button: BaseSelectFilter = {
    key: 'buttonName',
    label: 'Кнопка',
    options: []
}

export function getMetricTitle(metric: MetricType): string {
    switch (metric) {
        case MetricType.retentionRate:
            return "Retention Rate";
        case MetricType.churnRate:
            return "Churn Rate";
        case MetricType.dau:
            return "DAU";
        case MetricType.mau:
            return "MAU";
        case MetricType.dailySessionsPerDau:
            return "Daily Sessions per DAU";
        case MetricType.stickiness:
            return "Stickiness (DAU/MAU)";
        case MetricType.demandLevel:
            return "Уровень спроса";
        case MetricType.viewsPerAd:
            return "Просмотров на объявление";
        case MetricType.totalViews:
            return "Всего просмотров";
        case MetricType.adViews:
            return "Просмотры объявлений";
        case MetricType.sellers:
            return "Продавцы";
        case MetricType.contactAttempts:
            return "Контакты";
        case MetricType.usersWithAds:
            return "Пользователи с объявлениями";
        case MetricType.usersWithMessages:
            return "Пользователи с сообщениями";
        case MetricType.screenTransitions:
            return "Цепочка переходов";
        case MetricType.transitionSource:
            return "Откуда был переход";
        case MetricType.timeInMenu:
            return "Время в меню";
        case MetricType.activityTime:
            return "Активность в приложении (время)";
        case MetricType.buttonClicks:
            return "Клики на главном экране";
        case MetricType.searchQueries:
            return "Поисковые запросы";
        case MetricType.phoneMasks:
            return "Маски телефонов";
        case MetricType.ipGeoposition:
            return "IP / Геопозиция";
        case MetricType.geopositionComposite:
            return "Геопозиция (сборная)";
        case MetricType.callButtonClicks:
            return "Клики на кнопку «Позвонить»";
        default:
            return "Неизвестная метрика";
    }
}

const platformCountryCityDate: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Дата/период",
        mode: "full"
    },
    selectFilters: [
        platform,
        countryName,
        cityName,
    ]
}

const countryCityDate: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Дата/период",
        mode: "full"
    },
    selectFilters: [
        countryName,
        cityName,
    ]
}

const platformCountryDate: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Дата/период",
        mode: "full"
    },
    selectFilters: [
        platform,
        countryName,
    ]
}

const platformCountryCityMonth: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Месяц/Год",
        mode: "monthYear"
    },
    selectFilters: [
        platform,
        countryName,
        cityName,
    ]
}

const platformCountryMonth: FilterConfig = {
    priceFilter: {
        isShow: false,
        label: ""
    },
    dateFilter: {
        isShow: true,
        label: "Месяц/Год",
        mode: "monthYear"
    },
    selectFilters: [
        platform,
        countryName,
    ]
}

export function getMetricFilterConfig(metric: AvailableMetricResponse): FilterConfig {
    const isAggregated = metric.metricType === 'aggregated'

    switch (metric.metricName) {
        // 1. Retention Rate
        // 2. Churn Rate
        case MetricType.retentionRate:
        case MetricType.churnRate:
            if (isAggregated) {
                return platformCountryDate
            }
            return platformCountryCityDate
        // 5. Daily Sessions per DAU
        case MetricType.dailySessionsPerDau:
            return platformCountryCityDate
        // 3. DAU
        case MetricType.dau:
            return platformCountryCityDate
        // 4. MAU
        case MetricType.mau:
            return platformCountryCityMonth
        // 6. Stickiness (DAU/MAU)
        case MetricType.stickiness:
            if (isAggregated) {
                return platformCountryMonth
            }
            return platformCountryCityMonth
        // 12. Уровень спроса
        // 26. Уровень спроса
        case MetricType.demandLevel:
        case MetricType.adDemandRate:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/Период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 16. Всего просмотров
        case MetricType.totalViews:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                    {
                        key: 'timeOfDay',
                        label: 'Время суток',
                        options: []
                    },
                ]
            }
        case MetricType.adViews:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 13. Просмотров на объявление
        case MetricType.viewsPerAd:
        case MetricType.callButtonClicks:
            if (isAggregated) {
                return {
                    priceFilter: {
                        isShow: false,
                        label: ""
                    },
                    dateFilter: {
                        isShow: true,
                        label: "Дата/период",
                        mode: "full"
                    },
                    selectFilters: [
                        {
                            key: 'category',
                            label: 'Раздел',
                            options: []
                        },
                        {
                            key: 'subcategory',
                            label: 'Подраздел',
                            options: []
                        },
                    ]
                }
            }
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    platform,
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 14. Продавцы
        case MetricType.sellers:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 15. Контакты
        case MetricType.contactAttempts:
            if (isAggregated) {
                return countryCityDate
            }
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },

                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                    {
                        key: 'contactType',
                        label: 'Тип контакта',
                        options: []
                    },
                ]
            }
        // 20. Пользователи с объявлениями
        case MetricType.usersWithAds:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 21. Пользователи с сообщениями
        case MetricType.usersWithMessages:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        // 17. Цепочка переходов
        case MetricType.screenTransitions:
            if (isAggregated) {
                return {
                    priceFilter: {
                        isShow: false,
                        label: ""
                    },
                    dateFilter: {
                        isShow: true,
                        label: "Дата/период",
                        mode: "full"
                    },
                    selectFilters: [
                        platform,
                        {
                            key: 'category',
                            label: 'Раздел',
                            options: []
                        },
                        {
                            key: 'subcategory',
                            label: 'Подраздел',
                            options: []
                        },
                    ]
                }
            }
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'screen',
                        label: 'Экран',
                        options: []
                    },
                ]
            }
        // 22. Откуда был переход
        case MetricType.transitionSource:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    platform,
                    {
                        key: 'sourceScreen',
                        label: 'Исходный экран',
                        options: []
                    },
                    {
                        key: 'targetScreen',
                        label: 'Целевой экран',
                        options: []
                    },
                    {
                        key: 'actionType',
                        label: 'Тип действия',
                        options: []
                    },
                ]
            }
        case MetricType.activeAdsCount:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        case MetricType.timeInMenu:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                ]
            }
        case MetricType.activityTime:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    platform,
                ]
            }
        case MetricType.buttonClicks:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    platform,
                    button,
                ]
            }
        // 19. Поисковые запросы
        case MetricType.searchQueries:
            if (isAggregated) {
                return {
                    priceFilter: {
                        isShow: false,
                        label: ""
                    },
                    dateFilter: {
                        isShow: true,
                        label: "Дата/период",
                        mode: "full"
                    },
                    selectFilters: [
                        {
                            key: 'hint',
                            label: 'Подсказка',
                            options: []
                        }
                    ]
                }
            }
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'hint',
                        label: 'Подсказка',
                        options: []
                    },
                    {
                        key: 'userType',
                        label: 'Тип пользователя',
                        options: []
                    },
                ]
            }
        case MetricType.phoneMasks:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    countryId,
                ]
            }
        case MetricType.ipGeoposition:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    countryId,
                    cityId,
                ]
            };
        case MetricType.geopositionComposite:
            if (isAggregated) {
                return {
                    priceFilter: {
                        isShow: false,
                        label: ""
                    },
                    dateFilter: {
                        isShow: true,
                        label: "Дата/период",
                        mode: "full"
                    },
                    selectFilters: [
                        cityId,
                        countryId,
                    ]
                }
            }
            return platformCountryCityDate
        // 18. Популярные фильтры
        case MetricType.popularFilters:
            if (isAggregated) {
                return {
                    priceFilter: {
                        isShow: false,
                        label: ""
                    },
                    dateFilter: {
                        isShow: true,
                        label: "Дата/период",
                        mode: "full"
                    },
                    selectFilters: [
                        platform,
                        {
                            key: 'userType',
                            label: 'Тип пользователя',
                            options: []
                        },
                        {
                            key: 'filterName',
                            label: 'Название фильтра',
                            options: []
                        },
                    ]
                }
            }
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: true,
                    label: "Дата/период",
                    mode: "full"
                },
                selectFilters: [
                    {
                        key: 'userType',
                        label: 'Тип пользователя',
                        options: []
                    },
                    {
                        key: 'category',
                        label: 'Раздел',
                        options: []
                    },
                    {
                        key: 'subcategory',
                        label: 'Подраздел',
                        options: []
                    },
                    {
                        key: 'filterName',
                        label: 'Название фильтра',
                        options: []
                    },
                ]
            }
        default:
            return {
                priceFilter: {
                    isShow: false,
                    label: ""
                },
                dateFilter: {
                    isShow: false,
                    label: ""
                },
                selectFilters: []
            };
    }
}